import(/* webpackMode: "eager" */ "/home/runner/work/holy_trinity/holy_trinity/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/holy_trinity/holy_trinity/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/holy_trinity/holy_trinity/src/components/ui/AppIcon.tsx");
